import { call, put, takeEvery } from "redux-saga/effects"

import { 
    GET_PRESTATIONS, 
    ADD_NEW_PRESTATION, 
    UPDATE_PRESTATION, 
    DELETE_PRESTATION 
} from "./actionTypes";

import {
    getPrestationsSuccess,
    getPrestationsFail,
    addPrestationSuccess,
    addPrestationFail,
    updatePrestationSuccess,
    updatePrestationFail,
    deletePrestationSuccess,
    deletePrestationFail,
   
} from "./actions"

import {
    getPrestations,
    addNewPrestation,
    updatePrestation,
    deletePrestation,
   
} from "helpers/prestations/prestations_backend_helper";
import { toast } from "react-toastify";

function* fetchPrestations() {
    try {
        const response = yield call(getPrestations)
        yield put(getPrestationsSuccess(response))
    } catch (error) {
        yield put(getPrestationsFail(error))
    }
}

function* onAddNewPrestation({ payload }) {
    try {

        
        const response = yield call(addNewPrestation, payload)

        console.log("RESPONSE:", response);
        yield put(addPrestationSuccess(response.prestation))
        toast.success(response.data.message, { autoClose: 2000 });
    } catch (error) {
        console.log("ERROR:", error);
        yield put(addPrestationFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

/*
function* onUpdatePrestation({ payload: data }) {
    try {
        const response = yield call(updatePrestation, data)
        yield put(updatePrestationSuccess(response))
        toast.success("Branch  Updated Successfully", { autoClose: 2000 });
    } catch (error) {
        yield put(updatePrestationFail(error))
        toast.error("Branch  Updated Failed", { autoClose: 2000 });
    }
}
    */

function* onUpdatePrestation({ payload}) {
    try {
        console.log("UPDATE: ", payload);
        const response = yield call(updatePrestation, payload)
        yield put(updatePrestationSuccess(response.prestation))
        toast.success(response.data.message, { autoClose: 2000 });
    } catch (error) {
        yield put(updatePrestationFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

function* onDeletePrestation({ payload: data }) {

    try {
        const response = yield call(deletePrestation, data)
        yield put(deletePrestationSuccess(response.prestationId))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(deletePrestationFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}


function* prestationSaga() {
    yield takeEvery(GET_PRESTATIONS, fetchPrestations)
    yield takeEvery(ADD_NEW_PRESTATION, onAddNewPrestation)
    yield takeEvery(UPDATE_PRESTATION, onUpdatePrestation)
    yield takeEvery(DELETE_PRESTATION, onDeletePrestation)
}

export default prestationSaga;